// Modules
import * as Yup from 'yup'

// Application
import { federalTaxIdValidator, maxBirthDateValidator, minBirthDateValidator, nameValidator, validCharactereName } from 'utils'
import { genderListForSocialName } from 'constants/'

const requiredFieldError = 'Campo obrigatório'

export const PersonalDataSchema = Yup.object().shape({
    name: Yup.string()
        .required(requiredFieldError)
        .test('name', 'Insira seu nome completo', (value: string | undefined): boolean => nameValidator(value))
        .test('name', 'Insira um nome válido', (value: string | undefined): boolean => validCharactereName(value)),
    genderIdentity: Yup.string().required(requiredFieldError),
    hasSocialName: Yup.boolean().when('genderIdentity', (genderIdentity, schema) =>
        genderListForSocialName.includes(genderIdentity) ? schema.required(requiredFieldError) : schema,
    ),
    socialName: Yup.string()
        .trim()
        .when('hasSocialName', {
            is: true,
            then: schema => schema.required(requiredFieldError),
        }),
    biologicalSex: Yup.string().required(requiredFieldError),
    cpf: Yup.string()
        .required(requiredFieldError)
        .min(14, 'Mínimo de 14 caracteres')
        .test('cpf', 'Insira um CPF válido', (value: string | undefined): boolean => federalTaxIdValidator(value)),
    birthDate: Yup.string()
        .required(requiredFieldError)
        .min(10, 'Preencha uma data de nascimento completa. Ex.: 10/05/1989.')
        .max(10, 'Preencha uma data de nascimento completa. Ex.: 10/05/1989.')
        .test('birthDate', 'O usuário deve ser maior que 18 anos', (value: string | undefined): boolean =>
            minBirthDateValidator(value),
        )
        .test('birthDate', 'Insira uma data válida', (value: string | undefined): boolean => maxBirthDateValidator(value)),
    term: Yup.boolean().oneOf([true], requiredFieldError),
})
